import {fetchJson} from "./lib/fetch";

export class LicenseNotificationAlert {
	static hide() {
		fetchJson(`/op/license/hideNotification`)
			.then(r => console.info(`license notification cleared`))
			.catch(err => console.error(`license notification hasn't been cleared`))
	}
}
